// extracted by mini-css-extract-plugin
module.exports = {"OVERLAY":"backgroundOverlay-module--OVERLAY--3p4T5","bial":"backgroundOverlay-module--bial--31bUv","ziel":"backgroundOverlay-module--ziel--3JO_K"};